import { DispatchBus } from './DispatchBus'
import { DispatchNoteBus } from "./DispatchNoteBus";
import { v_DispatchAttachmentBus } from "./v_DispatchAttachmentBus";
import { v_DispatchEquipmentSvcdBus } from "./v_DispatchEquipmentSvcdBus";
import { DispatchAssignmentBus } from './DispatchAssignmentBus';
import { DispatchLaborBus } from './DispatchLaborBus';
import { DispatchPartsRequestedBus } from './DispatchPartsRequestedBus';
import { DQOIErrorBus } from "./DQOIError";
import { DispatchCustPartsBus } from "./DispatchCustPartsBus";
import { DispatchKudosBus } from "./DispatchKudosBus";
import { DispatchPartsBus } from "./DispatchPartsBus";
import { DispatchRefTrackingBus } from './DispatchRefTrackingBus';
import { v_DispatchNoteBus } from './v_DispatchNoteBus';
import { KudosAndOpportunityBus } from './KudosAndOpportunityBus';

export class DispatchSaveParam extends DispatchBus {
    constructor(data: DispatchBus) {
        super(data);
    }
    notes: DispatchNoteBus[];
    injuryNotes: DispatchNoteBus[];
    assignments: DispatchAssignmentBus[];
    attachments: v_DispatchAttachmentBus[];
    equipment: v_DispatchEquipmentSvcdBus[];
    partsReq: DispatchPartsRequestedBus[];
    parts: DispatchPartsBus[];
    custParts: DispatchCustPartsBus[];
    labor: DispatchLaborBus[];
    errors: DQOIErrorBus[];
    kudos: DispatchKudosBus[];
    refTracking: DispatchRefTrackingBus[];
    callbackNote: DispatchNoteBus;
    kudosAndOpp: KudosAndOpportunityBus[];
}
